:host {
  display: table-cell;
  border-bottom: 1px solid #ccc;
  --horizontal-align: left;
}

.br-table-cell {
  color: var(--color);
  font-size: var(--font-size-scale-base);
  font-weight: var(--font-weight-medium);
  padding: var(--table-row-size) var(--table-padding);
  text-align: var(--horizontal-align);

  &.vertical-border {
    border-left: 1px solid #ccc;
  }
}
